import { GithubIcon } from '@sketchnote/icons';
import React from 'react';

import { Header } from '../../quick-help';
import { useBoardExpStore } from '../store';

export const Integrations = (): JSX.Element => {
  const { closeExploreMenu, setNavigation } = useBoardExpStore();

  const hanldeCloseMenu = () => {
    closeExploreMenu();
  };
  const handleOnBack = () => {
    setNavigation('home');
  };

  return (
    <div>
      <div className="h-60 bg-white sticky top-0 z-10">
        <Header title="" onBackClick={handleOnBack} onCloseClick={hanldeCloseMenu} />
      </div>
      <div className="mb-24">
        <span
          role="img"
          aria-label="heading"
          className="text-gray-999 block mb-6 font-medium text-lg"
        >
          📲 &nbsp; Integrations
        </span>
        <div className="text-sm text-gray-600">Choose from connected integrations</div>
      </div>
      <div className="flex">
        <div className="mr-16">
          <GithubIcon size={42} />
        </div>
        <div>
          <div className="text-base font-semibold">GitHub</div>
          <div className="text-sm text-gray-600 mb-8 font-medium">Software Development</div>
          <div className="text-sm text-gray-600 mb-8">
            Connect your GitHub repository a to track and create issues on this file
          </div>
          <button
            type="button"
            onClick={() => setNavigation('github')}
            className="text-primary-500 text-sm font-medium"
          >
            Connect →
          </button>
        </div>
      </div>
    </div>
  );
};
